export const HOME = {
  emergentLink: "emergent-link",
};

export const NAV = {
  brand: "nav-brand",
  catalog: "nav-link-catalog",
  how: "nav-link-how",
  faq: "nav-link-faq",
  contact: "nav-link-contact",
  whatsapp: "nav-whatsapp-btn",
  cartBtn: "nav-cart-btn",
};

export const PRODUCT = {
  card: (ref) => `product-card-${ref}`,
  openBtn: (ref) => `product-open-${ref}`,
  dialog: "product-dialog",
  sizeRadio: (size) => `product-size-${size}`,
  faixaInput: "product-faixa-input",
  addCart: "product-add-cart-btn",
  buyNow: "product-buy-now-btn",
};

export const CART = {
  drawer: "cart-drawer",
  item: (idx) => `cart-item-${idx}`,
  remove: (idx) => `cart-remove-${idx}`,
  inc: (idx) => `cart-inc-${idx}`,
  dec: (idx) => `cart-dec-${idx}`,
  customerName: "cart-customer-name",
  customerPhone: "cart-customer-phone",
  velorio: "cart-velorio",
  deliveryDate: "cart-delivery-date",
  notes: "cart-notes",
  sendBtn: "cart-send-whatsapp-btn",
  clearBtn: "cart-clear-btn",
};

export const FLOATING = {
  whatsapp: "floating-whatsapp-btn",
};

export const FILTER = {
  all: "filter-all",
  basic: "filter-basic",
  medium: "filter-medium",
  premium: "filter-premium",
  luxury: "filter-luxury",
};
